import React from 'react';
import Fade from 'react-reveal/Fade';
import Particles from "react-tsparticles";
import particlesConfig from "../../particles-config/config";
import { Typewriter } from "react-simple-typewriter";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

import './Contact.css';

function Contact() {

    const particlesInit = (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
      };
    
      const particlesLoaded = (container) => {
        console.log(container);
      };

  return (
  <div>
      <Particles
        className="part"
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particlesConfig}
      />

      <div className='contact'>
            <Fade top>
            <h1 className='contact-heading'>Want to connect with me?</h1>
            </Fade>

            <Fade left>
            <h1>Follow Me on
            <span
              style={{ color: "#1e8fe0", fontWeight: "bold", marginLeft: "10px" }}
            >
              <Typewriter
                loop
                cursor
                cursorStyle=""
                typeSpeed={70}
                deleteSpeed={80}
                delaySpeed={1200}
                words={["Linkedin", "Github", "Instagram"]}
              />
            </span>
            </h1>
            </Fade>

            <Fade bottom>
            <div >
                <a href="https://www.linkedin.com/in/ashish-kumar-780a3a1a4/" target="__blank"><FaLinkedin className='linkedin-icon' style={{height:'80px', width:'80px'}}/></a>
                <a href="https://github.com/McAsh09" target="__blank"><FaGithub className='git-icon' style={{height:'80px', width:'80px'}}/></a>
                <a href="https://www.instagram.com/aa.sheeeesh/" target="__blank"><FaInstagram className='insta-icon' style={{height:'80px', width:'80px'}}/></a>

            </div>
            </Fade>
      </div>
  </div>
  );
}

export default Contact;
